/**
 * Atlas PM · TanStack Query Key 工厂
 *
 * ⭐ p3-map / p3-star / p3-detail 做缓存失效时，必须复用这里的 key，
 *    不要各写各的字符串数组，否则缓存失效会失效（字面量不相等）。
 *
 * 用法：
 *   useQuery({ queryKey: qk.projects({ provinceCode: '330000' }), queryFn: ... })
 *   queryClient.invalidateQueries({ queryKey: qk.tasks({ projectId }) })
 *
 * 说明：工厂返回 `as const` 的只读元组，便于 TanStack Query 的类型收窄。
 */
export const qk = {
  me: () => ['me'] as const,

  // ── 项目 ──
  projects: (p?: unknown) => ['projects', p] as const,
  projectMap: (p?: unknown) => ['projects', 'map', p] as const,
  projectStats: (p?: unknown) => ['projects', 'stats', p] as const,
  project: (id: string) => ['projects', id] as const,
  /** ⭐ P6.54 项目级齐套率（实时口径） */
  projectCompleteness: (id: string) => ['projects', id, 'completeness'] as const,

  // ── 任务 ──
  tasks: (p?: unknown) => ['tasks', p] as const,
  task: (id: string) => ['tasks', id] as const,
  taskTree: (projectId: string) => ['tasks', 'tree', projectId] as const,
  taskGraph: (id: string) => ['tasks', 'graph', id] as const,
  taskProgress: (id: string) => ['tasks', id, 'progress'] as const,

  // ── 任务子资源 ──
  metrics: (taskId: string) => ['tasks', taskId, 'metrics'] as const,
  completeness: (taskId: string) => ['tasks', taskId, 'completeness'] as const,

  // ── 审批 ──
  approvals: (p?: unknown) => ['approvals', p] as const,
  approval: (id: string) => ['approvals', id] as const,

  // ── 操作日志 ──
  auditLogs: (p?: unknown) => ['audit', 'logs', p] as const,
  auditVerify: () => ['audit', 'verify'] as const,

  // ── 元数据 ──
  /** 省级行政区清单（来自 /geo/china.json，34 个） */
  provinces: () => ['geo', 'provinces'] as const,
} as const;
